// import { Redirect, Switch, useLocation, Route } from 'react-router-dom';
import { CertificateWidget } from 'modules/documents';
import React from 'react';
import { useParams } from 'react-router-dom';

export const CertificateTemplate = () => {
  const { id, platform } = useParams();
  return <CertificateWidget id={id} platform={platform} />;
};
